import { render } from "./wuxing.vue?vue&type=template&id=055f609a&scoped=true"
import script from "./wuxing.vue?vue&type=script&lang=js"
export * from "./wuxing.vue?vue&type=script&lang=js"

import "./wuxing.vue?vue&type=style&index=0&id=055f609a&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-055f609a"]])

export default __exports__